export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-2.5" aria-label="BPMedLav — Studio di Medicina del Lavoro">
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" aria-hidden="true">
      <rect width="36" height="36" rx="10" fill={dark ? "#F8F7F5" : "#17141F"} />
      <path
        d="M6.5 19h5l2.6-7.5 4.2 14 2.6-6.5h8.6"
        stroke="#E4002B"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    <span
      className={`font-display text-[22px] font-bold tracking-tight leading-none ${
        dark ? "text-paper" : "text-ink"
      }`}
    >
      BPMed<span className="text-clinic">Lav</span>
    </span>
  </span>
);
